import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/low_energy.png")